import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'vp-jumbotron',
    templateUrl: './jumbotron.component.html',
    styleUrls: ['./jumbotron.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIconButton, MatIcon]
})
export class JumbotronComponent {
    @Input() public closable: boolean;
    @Input() public title: string;
    @Input() public imageSrc: string;

    @Output() public close = new EventEmitter<void>();

    public onClose(): void {
        this.close.emit();
    }
}
